import Icon from './Icon';
import React from 'react';
import { screenNav } from '../state/states';

export default function Imprint() {
    return (
        <div
            className={`absolute z-[100] mx-auto flex h-auto w-full flex-col rounded-2xl bg-white bg-opacity-50 py-5 tracking-wide`}
        >
            <Icon name="logo" className="mx-auto mb-6 max-h-16" />
            <button
                onClick={() => screenNav.set('')}
                className="m-0 mb-2 border-none bg-transparent p-0 text-gray-600 text-inherit hover:cursor-pointer hover:underline"
            >
                Zurück zur Startseite
            </button>
            <section className={'mx-auto max-h-[calc(100vh-160px)] max-w-2xl overflow-auto'}>
                <h1>Impressum</h1>
                <address>
                    HerbEnergy GmbH
                    <br />
                    Rosenweg 8a
                    <br />
                    3110 Münsingen
                    <br />
                    Schweiz
                </address>
                <h2>Vertretungsberechtigte Personen</h2>
                <p>Dominik Herboldsheimer</p>
                <h2>Handelsregister</h2>
                <p>UID: CHE-227.928.686</p>
                <h2>Kontakt</h2>
                <p>
                    E-Mail: <a href="mailto:info@herbenergy.ch">info@herbenergy.ch</a>
                </p>
                <h2>Haftungsausschluss</h2>
                <ol>
                    <li>
                        <strong>Inhalte</strong>
                        <br />
                        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Gewähr für
                        die Aktualität, Vollständigkeit und Richtigkeit der bereitgestellten
                        Informationen. Jegliche Haftungsansprüche gegen uns, die sich auf Schäden
                        materieller oder ideeller Art beziehen – verursacht durch die Nutzung oder
                        Nichtnutzung der dargebotenen Inhalte bzw. durch Nutzung fehlerhafter und
                        unvollständiger Informationen – sind grundsätzlich ausgeschlossen.
                    </li>
                    <li>
                        <strong>Externe Links</strong>
                        <br />
                        Unsere Webseite enthält Links zu externen Websites Dritter, auf deren
                        Inhalte wir keinen Einfluss haben. Deshalb übernehmen wir für diese fremden
                        Inhalte auch keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets
                        der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                    </li>
                    <li>
                        <strong>Urheberrecht</strong>
                        <br />
                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser
                        Website unterliegen dem schweizerischen Urheberrecht. Beiträge Dritter sind
                        als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung
                        und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen
                        unserer schriftlichen Zustimmung.
                    </li>
                    <li>
                        <strong>Änderungen und Irrtümer</strong>
                        <br />
                        Wir behalten uns ausdrücklich vor, Teile der Seiten oder das gesamte Angebot
                        jederzeit zu ändern, zu ergänzen, zu löschen oder die Veröffentlichung
                        zeitweise oder endgültig einzustellen. Sollten einzelne Formulierungen oder
                        Darstellungen dieses Haftungsausschlusses unwirksam sein, bleiben die
                        übrigen Bestimmungen davon unberührt.
                    </li>
                </ol>
            </section>
        </div>
    );
}
